const config = Object.freeze({
  SQS_EMAIL_URL: process.env.REACT_APP_SQS_EMAIL_URL,
  SQS_LOG_URL: process.env.REACT_APP_SQS_LOG_URL,
  AWS_REGION: process.env.REACT_APP_AWS_REGION,
  FARMER_MOBILE_PREFIX: process.env.REACT_APP_FARMER_MOBILE_PREFIX,
  API_BASE_PATH: process.env.REACT_APP_API_BASE_PATH,
  LOGGING_API_KEY: process.env.REACT_APP_LOGGING_API_KEY,

  STAFF_POOL_ID: process.env.REACT_APP_STAFF_POOL_ID,
  STAFF_POOL_WEB_CLIENT_ID: process.env.REACT_APP_STAFF_POOL_WEB_CLIENT_ID,
  STAFF_IDENTITY_POOL_ID: process.env.REACT_APP_STAFF_IDENTITY_POOL_ID,
  TINY_MCE_ACCESS_KEY: process.env.REACT_APP_TINY_MCE_ACCESS_KEY,
  GTM_KEY: process.env.REACT_APP_GTM_KEY,
});

export default config;
